var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIndicatorArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24.561,
  height: 31.561
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "indicator-arrow_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  transform: "translate(386.541 702.08)",
  fill: "currentColor",
  stroke: "currentColor",
  d: "M0 0h31.561v24.561H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(90 556.591 170.05)",
  clipPath: "url(#indicator-arrow_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 159",
  d: "m415.73 714.351-10.742-10.742"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 160",
  d: "m415.73 714.351-10.742 10.742"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 54",
  d: "M386.54 714.634h29.114"
})))));
export default SvgIndicatorArrow;